import firebase from 'firebase/app';
import 'firebase/messaging';
import DeviceApi from '../Resources/Pro/Devices/DeviceApi';

const PUSH_DEFAULT = 'default';
const PUSH_ENABLED = 'granted';
const PUSH_BLOCKED = 'denied';

class BrowserPush {
  constructor() {
    this.isInitialized = false;
    this.messaging = null;
    this.registeredCallbacks = [];
  }

  isPushCapable() {
    return firebase.messaging.isSupported();
  }

  isPushDefault() {
    return this.permission() === PUSH_DEFAULT;
  }

  isPushEnabled() {
    return this.permission() === PUSH_ENABLED;
  }

  isPushBlocked() {
    return this.permission() === PUSH_BLOCKED;
  }

  permission() {
    return Notification.permission;
  }

  disconnect() {
    if (this.isInitialized) { 
      return this.messaging.deleteToken();
    }
  }

  monitor(config, vapidKey) {
    if (this.isPushCapable() && this.isPushEnabled()) {
      this.initializeFirebase(config);
      this.initServiceWorker();
      this.retrieveAndPersistToken(vapidKey);
      this._setupFirebaseListeners();
    }
  }

  initializeFirebase(config) {
    if (!this.isInitialized) {
      firebase.initializeApp(config);

      const messaging = firebase.messaging();

      this.isInitialized = true;
      this.messaging = messaging;
    }
  }

  initServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js').then(
        (response) => {
          // Service worker registration done
          console.log('Registration Successful', response);
        },
        (error) => {
          // Service worker registration failed
          console.log('Registration Failed', error);
        }
      );
    }
  }

  requestPermission() {
    return Notification.requestPermission().then((permission) => {
      if (this.isPushEnabled()) {
        this.initializeFirebase(window.FIREBASE_CONFIGURATION);
        return this.retrieveAndPersistToken().then(() => permission);
      } else {
        /**
         * If permission dialog is closed by the user, Chrome will return 'default' in the Promise, but actually set
         * the permission to Deny on the 3rd time they have closed it for a domain. You must manually fetch the
         * permission to see which value it is.
         */
        return this.permission();
      }
    });
  }

  retrieveAndPersistToken(vapidKey) {
    return this.messaging.getToken({ vapidKey }).then((currentToken) => {
      DeviceApi.persistBrowserToken(currentToken);
    });
  }

  _setupFirebaseListeners() {
    const allCallbacks = (payload) => {
      this.registeredCallbacks.forEach((callback) => {
        callback(payload);
      });
    };

    this.messaging.onMessage(allCallbacks);
  }

  registerListener(callback) {
    if (!this.isInitialized || !this.messaging) throw new Error('BrowserPush needs to be initialized');

    this.registeredCallbacks = [...this.registeredCallbacks, callback];
  }
}

const bp = new BrowserPush();

export default bp;
